import React from 'react';
import { ReferenceLine } from 'recharts';
import type { ChartTargetReference } from './canvasChartData';

const refCommon = {
	strokeWidth: 1.5,
	strokeDasharray: '5 4',
	ifOverflow: 'extendDomain' as const,
	isAnimationActive: false,
};

export default function ChartTargetReferenceLines({
	reference,
	stroke,
}: {
	reference: ChartTargetReference;
	stroke: string;
}) {
	if (reference.kind === 'none') {
		return null;
	}
	if (reference.kind === 'flat') {
		return <ReferenceLine y={reference.y} stroke={stroke} {...refCommon} />;
	}
	return <ReferenceLine segment={reference.segment} stroke={stroke} {...refCommon} />;
}
